import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {AlertTextComponent} from "./alert-text.component";

@NgModule({
  imports: [CommonModule],
  declarations: [AlertTextComponent],
  exports: [AlertTextComponent],
})
export class AlertTextModule {}



// WEBPACK FOOTER //
// ./src/app/utils/alert-text/alert-text.module.ts